import { Infer, literal, string, type } from "superstruct";
import { getFirebaseFunctionDefinition } from "../../utils/getFirebaseFunctionDefinition";

const DeleteWebhookConfigRequestStruct = type({
  /**
   * Organization ID to delete webhook config for.
   */
  organizationId: string(),
});

const DeleteWebhookConfigResponseStruct = type({
  /**
   * Confirmation that the webhook was deleted.
   */
  status: literal("deleted"),
});

export type DeleteWebhookConfigRequest = Infer<
  typeof DeleteWebhookConfigRequestStruct
>;
export type DeleteWebhookConfigResponse = Infer<
  typeof DeleteWebhookConfigResponseStruct
>;

export const deleteWebhookConfigDefinition = getFirebaseFunctionDefinition({
  path: "/webhooks/delete-config",
  reqType: DeleteWebhookConfigRequestStruct,
  resType: DeleteWebhookConfigResponseStruct,
});
